import { createIcon } from "@chakra-ui/react";

export const Image = createIcon({
  displayName: "Image",
  viewBox: "0 0 24 24",
  d: "M5.571 5.757a.645.645 0 0 0-.642.642v12.858c0 .353.289.642.642.642H18.43c.353 0 .642-.289.642-.642V6.399a.645.645 0 0 0-.642-.642H5.57zM3 6.399a2.574 2.574 0 0 1 2.571-2.571H18.43A2.574 2.574 0 0 1 21 6.399v12.858a2.574 2.574 0 0 1-2.571 2.571H5.57A2.574 2.574 0 0 1 3 19.257V6.399zm5.143 1.286c.711 0 1.286.575 1.286 1.286 0 .711-.575 1.286-1.286 1.286A1.284 1.284 0 0 1 6.857 8.97c0-.711.575-1.286 1.286-1.286zm5.464 2.893c.342 0 .66.18.832.474l3.214 5.464a.96.96 0 0 1 .004.969.962.962 0 0 1-.836.486H7.18a.968.968 0 0 1-.856-.518.967.967 0 0 1 .064-.997l2.25-3.214a.964.964 0 0 1 .792-.41c.317 0 .61.153.791.41l.691.988 1.869-3.174a.966.966 0 0 1 .831-.474l-.004-.004z",
  defaultProps: {
    "aria-label": "A image"
  }
});

export default Image;
